exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-footer[data-v-766e5f2e]{max-width:23vh;margin-bottom:-10px;padding-right:10px}.menu-name[data-v-766e5f2e]{height:30px;line-height:13px;font-size:14px;position:relative;font-weight:600;display:block;width:60px;text-align:left;text-transform:capitalize;white-space:normal}.q-layout-footer .q-tabs .q-tab[data-v-766e5f2e]{padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-766e5f2e","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Footer.vue
// module id = TcSp
// module chunks = 57